import { useAppStore } from "@hooks/useAppStore";
import type { SectionTag } from "@memorang/ui/components/FilterSections/types";
import { useMemo } from "react";
import { buildDisplaySectionTags } from "../helpers/session-filters";
import { LearningModes } from "../types";

export const useDisplaySectionTags = ({
	sectionTags,
	selectedLearningMode,
	structuredTagCounts,
	unavailableQuestionTypeIds,
}: {
	sectionTags: SectionTag[] | undefined;
	selectedLearningMode: string;
	structuredTagCounts: Record<number, number>;
	unavailableQuestionTypeIds: Set<number>;
}) => {
	const proficiencyLabelOverride = useAppStore(
		(state) => state.sessionView?.configOverrides?.proficiencyLabel,
	);

	const filteredSectionTags = useMemo(() => {
		if (!sectionTags) {
			return undefined;
		}
		const isEssayMode = selectedLearningMode === LearningModes.essays;
		return sectionTags.filter((section) =>
			isEssayMode
				? section.title.toLowerCase() === "writing"
				: section.title.toLowerCase() !== "writing",
		);
	}, [sectionTags, selectedLearningMode]);

	const displaySectionTags = useMemo(() => {
		if (!filteredSectionTags) {
			return undefined;
		}
		return buildDisplaySectionTags({
			sections: filteredSectionTags,
			structuredTagCounts,
			unavailableQuestionTypeIds,
			proficiencyLabelOverride,
		});
	}, [
		filteredSectionTags,
		structuredTagCounts,
		unavailableQuestionTypeIds,
		proficiencyLabelOverride,
	]);

	return { filteredSectionTags, displaySectionTags };
};
